/**
 * @file paddlex 历史版本
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import Header from '../../../../components/header/HeaderWithStore';
import Footer from '../../../../components/footer/footer';
import HistoryVersionTable from '../../components/history-version-table/HistoryVersionTable';
import usePaddlexHistoryHooks from './paddlexHistoryHooks';

const PaddlexHistory: React.FC = props => {
    const {
        historyVersion
    } = usePaddlexHistoryHooks();

    return (
        <div className="page paddlex-history-page">
            <Header />
            <div className="paddlex-history-container">
                <div className="paddlex-download-h2">
                    历史版本
                </div>
                <HistoryVersionTable
                    dataSource={historyVersion}
                    pagination={false}
                />
            </div>
            <Footer />
        </div>
    );
};

export default PaddlexHistory;
